import { Button } from "antd"
import Hamburger from "hamburger-react"
import React, { useEffect, useState } from "react"
import { useNavigate, Link, useLocation } from "react-router-dom"
import { useAppSelector } from "store/hooks"
import AppLogo from "../../../assets/images/mainLogo.svg"
import CustomDrawer from "./CustomDrawer"
import NavDropDowns from "./NavDropDowns"
import "./TopBar.scss"
const TopBar = () => {
    const [isOpen, setOpen] = useState(false)
    const location = useLocation();
    const navigate = useNavigate()
    const { isAuthenticated, user } = useAppSelector((state) => state.user)
    const onStudentPortalClickHandler = () => {
        if(isAuthenticated && user?.role==="Student") {
           navigate("/student");
        }
        else {
            navigate("/portal")

        }
    }
    useEffect(()=>{
    if(isOpen) {
        setOpen(false);
    }
    },[location])
    return (
        <div className="mainTopBar">
            <div className="container mainTopBar__content">
                <div className="leftSection">
                    <Link to="/" className="nav-brand">
                        <img alt="appLogo" src={AppLogo} />
                    </Link>
                    <Button
                        className="btnWhiteVariant text-underline btnDonate"
                        onClick={() =>
                            window.open(
                                "https://givebutter.com/Vo9aqn",
                                "_blank"
                            )
                        }
                    >
                        Donate
                    </Button>
                </div>
                <div className="rightSection">
                    <NavDropDowns />
                    <Button
                        className="btnWhiteVariant  btn-primary"
                        onClick={onStudentPortalClickHandler}
                    >
                        Student Portal
                    </Button>
                </div>
                <div className="mobileRightSection">
                    <Hamburger
                        toggled={isOpen}
                        toggle={setOpen}
                        color="#000"
                        size={25}
                    />
                    {isOpen && <CustomDrawer />}
                </div>
            </div>
        </div>
    )
}

export default TopBar
